import type { IssueActionProgressType } from '@issuemanager/constants';

interface GetIssueStatesParams {
  actionProgress: IssueActionProgressType;
}

interface IssueStates {
  isWorkflowInitiated: boolean;
}

/**
 *
 * @param {GetIssueStatesParams} data
 * @desc Get derived states from issue data
 * @returns {IssueStates}
 */
export function getIssueStates(data?: GetIssueStatesParams): IssueStates {
  if (!data) {
    return {
      isWorkflowInitiated: false,
    };
  }

  return {
    // TODO: Add and document more issue states here
    isWorkflowInitiated: !Array.from<IssueActionProgressType>([
      'blank',
      'not-initiated',
    ]).includes(data.actionProgress),
  };
}
